import React from 'react';
import './Mission.css';

import { mission } from '../../../constants';
import { Heading } from '../../../components';



const Mission = () => {

  const { sub, heading, content, points } = mission;

  return (
    <section className="custom-form mission">

      {/* Content Container */}
      <div className="box-container">

        <div className='content'>
          <div className='text'>

            {/* Section Heading */}
            <Heading title={heading} subTitle={sub} linear sideHeading />

            {/* Mission Paragraph */}
            <p>{content}</p>

            {/* Mission Points */}
            <div className="mission-points">
              {points.map((item) => (
                <li key={item.id}>
                  <div className='icon'>{item.icon}</div>
                  <div className='text'>
                    <h5>{item.title}</h5>
                    <p>{item.content}</p>
                  </div>
                </li>
              ))}
            </div>

          </div>
        </div>

      </div>

    </section>
  );
};

export default Mission;